import Vue from 'vue'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'
import VueRouter from 'vue-router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCameraAlt, faBars } from '@fortawesome/pro-regular-svg-icons'
import { faTwitter, faInstagram, fa500px } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import router from '@/router';

library.add(faCameraAlt)
library.add(faBars)
library.add(faTwitter)
library.add(faInstagram)
library.add(fa500px)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(VueLazyload)
Vue.use(VueRouter)


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
